exports.components = {
  "component---src-components-templates-people-js": () => import("./../../../src/components/templates/people.js" /* webpackChunkName: "component---src-components-templates-people-js" */)
}

